import { render, staticRenderFns } from "./AdminOrderMessage.vue?vue&type=template&id=12924e92&scoped=true&"
import script from "./AdminOrderMessage.vue?vue&type=script&lang=js&"
export * from "./AdminOrderMessage.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrderMessage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AdminOrderMessage.vue?vue&type=style&index=1&id=12924e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12924e92",
  null
  
)

export default component.exports